import { TonConnectButton } from "@tonconnect/ui-react";

import { Trans } from "react-i18next";

import level0 from "@/assets/images/level-0.png";
import { Levels } from "@/components/Levels";
import { Score } from "@/components/Score";
import { Stars } from "@/components/Stars";
import { HAPI_URL } from "@/constants";
import { getLevels } from "@/utils/levels";
import { t } from "i18next";

import { Network } from "@/interfaces/network";



import styles from "./styles";
import { useStore } from "@/hooks/store";
export const ConnectButton = ({ isConnected }: { isConnected: boolean }) => {
  if (isConnected) return;

  return (
    <styles.ConnectWalletWrapper>
      <styles.ConnectWalletTitle>
        <Trans i18nKey="Home.HapiScore.ConnectWallet" components={{ br: <br /> }} />
      </styles.ConnectWalletTitle>
      <TonConnectButton className="ton-connect" />
    </styles.ConnectWalletWrapper>
  );
};



export const HomeSkeleton: React.FC<{ isUserLoading: boolean }> = ({ isUserLoading }) => {
  const { user } = useStore((store) => ({
    user: store.user,
  }));

  const mint = {
    handler: () => { },
    loading: false,
    disabled: true,
  };

  const mintNFT = {
    handler: () => { },
    loading: false,
    isSoldOut: false,
    isPurchased: false,
    minAllowedScore: 0,
  };

  const levelsData = getLevels({
    mint,
    mintNFT,
    userLevel: 0,
    userScore: 0,
    openLevelModal: () => { },
    network: Network.NEAR,
    news: { url: null, action: () => { } },
    socials: {
      x: false,
      telegram: false,
    },
  });

  const isTonConnected = Boolean(user.tonAccount);

  return (
    <styles.HomeContainer>
      <Stars />
      <styles.TitleDescription>
        <div style={{ height: 24 }}>{"(￣_￣)"}</div>
        <styles.Title>{t("Home.HapiScore.Title")}</styles.Title>
        <styles.Description>{t("Home.HapiScore.Description")}</styles.Description>
        <styles.LearMore onClick={() => window.open(HAPI_URL)}>{t("Actions.LearnMore")}</styles.LearMore>
      </styles.TitleDescription>
      <styles.Score>
        {!isUserLoading && <ConnectButton isConnected={isTonConnected} />}
        <Score
          score={0}
          levelData={{
            img: level0,
            level: 0,
          }}
        />
      </styles.Score>
      <styles.Body>
        <Levels levels={levelsData} hideAction />
      </styles.Body>
    </styles.HomeContainer >
  );
};
